<template>
    <div>
        <div class="panel animated fadeInLeftBig">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Editar Banner</h3>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-6">
                            <label for="name">Nome do Banner</label>
                            <input type="text" class="form-control" name="name" v-model="highlight.title" id="name">
                        </div>

                        <div class="col-md-6">
                            <label for="status">Status</label>
                            <select name="status" id="status" v-model="highlight.status" class="form-control">
                                <option value="ati">Ativo</option>
                                <option value="ina">Inativo</option>
                            </select>
                        </div>

                        <div class="col-md-6 m-t-sm">
                            <label for="start">De</label>
                            <input type="date" name="start" id="start" class="form-control" v-model="highlight.start">
                        </div>

                        <div class="col-md-6 m-t-sm">
                            <label for="end">Até</label>
                            <input type="date" name="end" id="end" class="form-control" v-model="highlight.end">
                        </div>
                    </div>

                    <div class="row m-t-sm">
                        <div class="col-md-6">
                            <label for="highlight_type_id">Tipo</label>
                            <select name="highlight_type_id" id="highlight_type_id"
                                    v-model="highlight.highlight_type_id" @change="changeType" class="form-control">
                                <option value="1">Produto</option>
                                <option value="2">Receita</option>
                                <option value="3">Externo</option>
                                <option value="4">Vídeo</option>
                            </select>
                        </div>

                        <div class="col-md-6" id="relation_div" v-if="relation">
                            <label for="">{{ label }}</label>
                            <select name="relation_id" id="relation_id" v-model="highlight.relation_id"
                                    class="form-control" style="padding:15px !important;"></select>
                        </div>

                        <div class="col-md-6" id="external_url" v-if="external">
                            <label for="">{{ label }}</label>
                            <input type="text" class="form-control" v-model="highlight.external_url">
                        </div>

                        <div class="col-md-12">
                            <label for="photo" class="m-t-sm">Banner</label>
                            <input type="file" name="photo" :change="highlight.photo" id="photo">
                        </div>
                    </div>

                    <hr>

                    <a class="btn btn-success" @click="save">Salvar</a>
                    <router-link to="/highlight" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                highlight: {
                    highlight_id: '',
                    highlight_type_id: 0,
                    relation_id: 0,
                    title: '',
                    photo: '',
                    external_url: "",
                    status: "",
                    start: '',
                    end: ''
                },
                relation: false,
                external: false,
                products: [],
                recipes: [],
                label: "Escolha"
            }
        },
        computed: {},
        methods: {
            changeType: function () {
                const self = this;
                const relations = [
                    {id: 0, label: 'Escolha', method: ''},
                    {
                        id: 1, label: 'Produto', method: function (id) {
                            self.loadRelations(id);
                        }
                    },
                    {
                        id: 2, label: 'Receita', method: function (id) {
                            self.loadRelations(id);
                        }
                    },
                    {id: 3, label: 'Externo', method: ''},
                    {id: 4, label: 'Link (YouTube)', method: ''},
                ];
                let plugin = $('#relation_id');

                if (plugin.data('select2')) {
                    plugin.select2('destroy');
                    plugin.empty();
                }

                $.each(relations, function (key, value) {
                    if (value.id == self.highlight.highlight_type_id) {
                        self.label = value.label;

                        if ([1, 2].indexOf(value.id) >= 0) {
                            self.relation = true;
                            self.external = false;

                            plugin.ready(function () {
                                value.method(value.id);
                            });
                        } else {
                            self.relation = false;
                            self.external = true;
                        }
                    }
                });
            },
            loadProduct: function () {
                const self = this;
                const api = self.$store.state.api + 'product?paginated=false';

                self.$http.get(api)
                    .then((response) => {
                        self.products = response.data.data;
                        let result = [];

                        $.each(self.products, function (key, value) {
                            let obj = {id: value.id, text: value.name};

                            if (obj.id === self.highlight.relation_id) {
                                obj['selected'] = true;
                            }

                            result.push(obj);
                        });

                        self.products = result;
                        self.loadRecipe();
                    })
                    .catch((error) => {
                        self.$message(null, 'Não foi possível buscar as informações referente aos Produtos');
                    });
            },
            loadRecipe: function () {
                const self = this;
                const api = self.$store.state.api + 'recipe?paginated=false';

                self.$http.get(api)
                    .then((response) => {
                        self.recipes = response.data.data;
                        let result = [];

                        $.each(self.recipes, function (key, value) {
                            let obj = {id: value.id, text: value.name};

                            if (obj.id === self.highlight.relation_id) {
                                obj['selected'] = true;
                            }

                            result.push(obj);
                        });

                        self.recipes = result;
                        self.changeType();
                    })
                    .catch((error) => {
                        self.$message(null, 'Não foi possível buscar as informações referente às Receitas');
                    });
            },
            loadRelations: function (id) {
                const self = this;
                let plugin = $('#relation_id');

                if (id === 1) {
                    plugin.select2({
                        data: self.products
                    });
                } else {
                    plugin.select2({
                        data: self.recipes
                    });
                }
            },
            save: function () {
                const id = this.$route.params.id;
                const api = this.$store.state.api + 'highlight/' + id;
                const self = this;

                let form = new FormData();
                let photo = document.getElementById('photo');
                let relation_value = $('#relation_id').val();

                form.append('title', self.highlight.title);
                form.append('photo', (photo.files[0]) ? photo.files[0] : '');
                form.append('highlight_type_id', self.highlight.highlight_type_id);
                form.append('relation_id', (relation_value) ? relation_value : 0);
                form.append('external_url', self.highlight.external_url);
                form.append('status', self.highlight.status);
                form.append('start', (self.highlight.start) ? self.highlight.start : '');
                form.append('end', (self.highlight.end) ? self.highlight.end : '');

                self.$http.post(api, form)
                    .then((response) => {
                        self.$message('Sucesso', `Banner atualizado com sucesso`, 'success');
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if (typeof self.errors === 'object') {
                            let html = '<ul>';

                            $.each(self.errors, function (key, value) {
                                html += '<li class="m-t-sm m-b-sm">' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getHighlight: function () {
                const id = this.$route.params.id;
                const api = this.$store.state.api + 'highlight/' + id;
                const self = this;

                self.$http.get(api)
                    .then((response) => {
                        self.highlight = response.data;

                        this.loadProduct();

                        if ([3, 4].includes(self.highlight.highlight_type_id)) {
                          self.external = true;
                          self.label = 'Link (YouTube)';
                        }
                    })
                    .catch((error) => {
                        self.$message('Erro', 'Ocorreu um erro ao buscar o Banner', 'error');
                    });
            }
        },
        mounted: function () {
            this.getHighlight();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .select2-dropdown select2-dropdown--above {
        z-index: 1000;
    }
</style>



// WEBPACK FOOTER //
// src/components/Highlight/Edit.vue